export const messages = {
  title: 'Award Catalog',
  createButton: 'Create Award',
  subtitle: 'Provide member benefits based on their purchase behavior',
  cancelDialogHeader: 'Cancel Award',
  cancelDialogDescription:
    'This Award has not been finalized and progress will be lost if you cancel. Do you wish to proceed?',
};
